import Axios from 'axios';

const axios = Axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 30000
});

const VENUE_ID = 7895;

export function sendOtp({ accountId, email }) {
    return axios.post('/loyalty/send-login', {
        accountId,
        email,
        venueId: VENUE_ID,
        identifierType: 'email'
    });
}

export function registerUser({ accountId, email }) {
    return axios.post('/loyalty/register', {
        accountId,
        email,
        venueId: VENUE_ID,
        identifierType: 'email'
    });
}

export function verifyOtp({ accountId, email, code }) {
    return axios.post('/loyalty/confirm-login', { accountId, email, code });
}

export function getLoyaltyProfile({ accountId, contactUuid }) {
    return axios.get('/loyalty/profile', {
        params: { accountId, contactUuid }
    });
}

export function updateProfile({ accountId, contactUuid, profile, optIns }) {
    return axios.patch('/loyalty/profile', {
        accountId,
        contactUuid,
        profile,
        optIns
    });
}

export default axios;
